
    import { Component, PropSync, Vue } from 'vue-property-decorator';
    import ButtonTooltip from '@/components/common/button-tooltip.vue';

    @Component({
        components: { ButtonTooltip },
    })
    export default class ConfirmRemoveDialog extends Vue {
        @PropSync('visible', { type: Boolean, required: true })
        visibleDialog!: boolean;

        close() {
            this.visibleDialog = false;
        }
    }
